import '@ant-design/v5-patch-for-react-19';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@qcdoc/shared/shared/theme/global.css';
import { startMockSync } from '@qcdoc/shared/mocks/sync/start.ts';
import App from './app/App.tsx';

startMockSync();
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);